<template>
  <div class="surface-design-print-placement">
    <TopPanel
      @search="surfaceDesignPrintPlacementsStore.searchByItems"
      @sort-order="surfaceDesignPrintPlacementsStore.setSortOrderItems"
      @sort-option="surfaceDesignPrintPlacementsStore.sortItems"
      :sort-options="sortOptions"
      backLink="/user/surface-design-print-placements"
      backText="Back to all prints"
      :title="surfaceDesignPrintPlacementsStore.selectedCollectionName"
      :needExtra="false"
      :create="false"
      @rename="editModal"
      @del="delModal"
      @edit="$router.push('/user/surface-design-print-placements-edit')"
    >
    </TopPanel>
    <EmptyGrid
      v-if="surfaceDesignPrintPlacementsStore.itemsCount === 0"
      @create-new="$router.push('/user/surface-design-print-placements-edit/')"
      :buttonPlusIcon="false"
      :buttonEditIcon="true"
    >
      <template v-slot:icon>
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 22 22">
          <path d="M4.582 2.916c-.912 0-1.666.756-1.666 1.668v12.832c0 .912.754 1.668 1.666 1.668h12.834c.912 0 1.666-.756 1.666-1.668V4.584c0-.912-.754-1.668-1.666-1.668H4.582zm-.018 1.5h12.852c.101 0 .166.067.166.168v12.832c0 .1-.065.168-.166.168H4.582c-.1 0-.166-.067-.166-.168V4.584c0-.095.058-.16.148-.168zM9.166 7.5c-.912 0-1.666.754-1.666 1.666v3.668c0 .912.754 1.666 1.666 1.666h3.668c.912 0 1.666-.754 1.666-1.666V9.166c0-.912-.754-1.666-1.666-1.666H9.166zM9.148 9h3.686c.101 0 .166.065.166.166v3.668c0 .101-.065.166-.166.166H9.166c-.1 0-.166-.065-.166-.166V9.166c0-.095.058-.158.148-.166z" />
        </svg>
      </template>
      <template v-slot:title>This collection is empty</template>
      <template v-slot:text>Click “Edit” button to add prints</template>
      <template v-slot:button-text>Edit collection</template>
    </EmptyGrid>
    <div v-else class="items">
      <div  class="item" v-for="item in surfaceDesignPrintPlacementsStore.items" :key="item.id">
        <div class="img-container"><img :src="`https://cdn.patternfast.com${item.url}`"/></div>
        <p v-if="item.name">{{item.name}}</p>
      </div>
    </div>
    <PaginationComponent
      :limit="surfaceDesignPrintPlacementsStore.itemsParams.limit"
      :offset="surfaceDesignPrintPlacementsStore.itemsParams.offset"
      :total="surfaceDesignPrintPlacementsStore.itemsCount"
      @setOffset="setOffset"
    />
    <ModalComponent @close="surfaceDesignPrintPlacementsStore.renameModalToggle()"
      :show="surfaceDesignPrintPlacementsStore.renameModal">
      <template v-slot:icon>
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 22 22">
          <path d="M4.582 2.916c-.912 0-1.666.756-1.666 1.668v12.832c0 .912.754 1.668 1.666 1.668h12.834c.912 0 1.666-.756 1.666-1.668V4.584c0-.912-.754-1.668-1.666-1.668H4.582zm-.018 1.5h12.852c.101 0 .166.067.166.168v12.832c0 .1-.065.168-.166.168H4.582c-.1 0-.166-.067-.166-.168V4.584c0-.095.058-.16.148-.168zM9.166 7.5c-.912 0-1.666.754-1.666 1.666v3.668c0 .912.754 1.666 1.666 1.666h3.668c.912 0 1.666-.754 1.666-1.666V9.166c0-.912-.754-1.666-1.666-1.666H9.166zM9.148 9h3.686c.101 0 .166.065.166.166v3.668c0 .101-.065.166-.166.166H9.166c-.1 0-.166-.065-.166-.166V9.166c0-.095.058-.158.148-.166z" />
        </svg>
      </template>
      <template v-slot:title>Rename collection</template>
      <template v-slot:extra>
        <label class="edit-collection-field">
          <span>Collection Name</span>
          <input type="text" placeholder="" v-model="surfaceDesignPrintPlacementsStore.collectionName">
        </label>
      </template>
      <template v-slot:buttons>
        <ButtonSecondary class="small" @click.native="surfaceDesignPrintPlacementsStore.renameModalToggle()">
          Cancel
        </ButtonSecondary>
        <ButtonPrimary class="small"
          :disabled="surfaceDesignPrintPlacementsStore.collectionName?.length === 0"
          @click.native="updateCollection"
        >
          Rename
        </ButtonPrimary>
      </template>
    </ModalComponent>
    <ModalComponent @close="surfaceDesignPrintPlacementsStore.delCollectionModalToggle()" type="error"
      :show="surfaceDesignPrintPlacementsStore.delCollectionModal">
      <template v-slot:title>Delete collection</template>
      <template v-slot:description>Are you sure? You will lose the prints that are in it</template>
      <template v-slot:buttons>
        <ButtonSecondary class="small" @click.native="surfaceDesignPrintPlacementsStore.delCollectionModalToggle()">
          Cancel
        </ButtonSecondary>
        <ButtonPrimary class="small" @click.native="deleteCollection">
          <template v-slot:icon>
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" stroke="none" viewBox="0 0 21 20">
              <path d="M8 1.75c-.866 0-1.584.718-1.584 1.584v.916H3.834a.75.75 0 0 0-.75.75.75.75 0 0 0 .75.75h.916v10.916c0 .866.718 1.584 1.584 1.584h8.332c.866 0 1.584-.718 1.584-1.584V5.75h.916a.75.75 0 0 0 .75-.75.75.75 0 0 0-.75-.75h-2.582v-.916c0-.866-.718-1.584-1.584-1.584H8zm0 1.5h5c.055 0 .084.03.084.084v.916H7.916v-.916c0-.055.03-.084.084-.084zm-1.75 2.5h8.5v10.916c0 .055-.03.084-.084.084H6.334c-.055 0-.084-.03-.084-.084V5.75z" color="#000" style="-inkscape-stroke:none"/>
            </svg>
          </template>
          Delete
        </ButtonPrimary>
      </template>
    </ModalComponent>
  </div>
</template>

<script>
import { mapStores } from 'pinia'
import { useSurfaceDesignPrintPlacementsStore } from '@/store/pinia/surfaceDesignPrintPlacements'
import TopPanel from '@/components/SurfaceDesign/TopPanel.vue'
import EmptyGrid from '@/components/Atoms/EmptyGrid.vue'
import ModalComponent from '@/components/Atoms/ModalComponent.vue'
import ButtonPrimary from '@/components/Atoms/ButtonPrimary.vue'
import ButtonSecondary from '@/components/Atoms/ButtonSecondary.vue'
import PaginationComponent from '@/components/Atoms/PaginationComponentLimit.vue'
export default {
  name: 'surfaceDesignPrintPlacement',
  data: () => ({
    sortOptions: [
      { name: 'Sort by', value: '' },
      { name: 'Name', value: 'name' },
      { name: 'Last edited', value: 'updatedAt' },
    ],
  }),
  components: {
    TopPanel,
    EmptyGrid,
    ModalComponent,
    ButtonPrimary,
    ButtonSecondary,
    PaginationComponent,
  },
  computed: {
    ...mapStores(useSurfaceDesignPrintPlacementsStore),
  },
  methods: {
    async setOffset (offset) {
      this.surfaceDesignPrintPlacementsStore.itemsParams.offset = offset
      const id = this.$route.params.id || this.surfaceDesignPrintPlacementsStore.selectedCollectionId
      await this.surfaceDesignPrintPlacementsStore.getItems(id)
    },
    deleteCollection () {
      this.surfaceDesignPrintPlacementsStore.deleteCollection()
      this.$router.push('/user/surface-design-print-placements/')
    },
    delModal () {
      this.surfaceDesignPrintPlacementsStore.delCollectionModalToggle()
      this.surfaceDesignPrintPlacementsStore.collectionId = this.surfaceDesignPrintPlacementsStore.selectedCollectionId
    },
    editModal () {
      this.surfaceDesignPrintPlacementsStore.renameModalToggle()
      this.surfaceDesignPrintPlacementsStore.collectionId = this.surfaceDesignPrintPlacementsStore.selectedCollectionId
      this.surfaceDesignPrintPlacementsStore.collectionName = this.surfaceDesignPrintPlacementsStore.selectedCollectionName
    },
    updateCollection () {
      this.surfaceDesignPrintPlacementsStore.selectedCollectionName = this.surfaceDesignPrintPlacementsStore.collectionName
      this.surfaceDesignPrintPlacementsStore.updateCollection()
    },
  },
  async beforeMount () {
    const id = this.$route.params.id || this.surfaceDesignPrintPlacementsStore.selectedCollectionId
    await this.surfaceDesignPrintPlacementsStore.getItems(id)
  },
}
</script>

<style lang="scss">
.surface-design-print-placement {
  padding: 0 16px 40px 40px;
  .items {
    display: flex;
    gap: 40px;
    margin-top: 42px;
    text-align: center;
    flex-wrap: wrap;
    p {
      margin: 8px 0 0;
      font-size: 14px;
      color: var(--Text-Text_Primary);
    }
    .img-container {
      width: 95px;
      height: 95px;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 8px;
      }
    }
  }
}
@media (max-width: 480px) {
  .surface-design-print-placement {
    padding: 0;
    .buttons-group {
      max-width: 100%;
    }
  }
}
</style>
